import { render } from "./Logout.vue?vue&type=template&id=5fcfea7f&scoped=true&ts=true"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"

import "./Logout.vue?vue&type=style&index=0&id=5fcfea7f&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcfea7f"]])

export default __exports__